import { toItem } from '../mappers/item';
export function mapPhotosetItemsList(res) {
  const {
    page,
    pages,
    perpage,
    photo = []
  } = res.data.photoset || {};
  const cursor = page < pages ? Number(page) + 1 : null;
  const size = Number(perpage);
  res.data = photo.map(toItem);
  res.paging = {
    cursor,
    size
  };
  return res;
}
export function mapPhotostreamItemsList(res) {
  const {
    page,
    pages,
    perpage,
    photo = []
  } = res.data.photos || {};
  const cursor = page < pages ? Number(page) + 1 : null;
  const size = Number(perpage);
  res.data = photo.map(toItem);
  res.paging = {
    cursor,
    size
  };
  return res;
}